// extracted by mini-css-extract-plugin
export var closeModalButton = "faq-inner-content-module--close-modal-button--s1m8C";
export var closeModalWrapper = "faq-inner-content-module--close-modal-wrapper--CCIqO";
export var content = "faq-inner-content-module--content--Wk52x";
export var faqModalBackdrop = "faq-inner-content-module--faq-modal-backdrop--GRZYS";
export var faqModalWrapper = "faq-inner-content-module--faq-modal-wrapper--1BO3K";
export var faq__heading = "faq-inner-content-module--faq__heading--gD65c";
export var faq__notFound = "faq-inner-content-module--faq__not-found--26ZyD";
export var faq__subHeading = "faq-inner-content-module--faq__sub-heading--MKIXS";
export var faq__wrapper = "faq-inner-content-module--faq__wrapper--L5aos";